import React from 'react'

const HtmlBlock = ({ block }) => {
  const containerRef = React.useRef(null)

  React.useEffect(() => {
    const container = containerRef.current
    if (!container) return
    let cancelled = false
    let observer = null

    const renderEmbed = async () => {
      container.innerHTML = ''
      const template = document.createElement('template')
      template.innerHTML = block.settings.copy || ''
      const scripts = Array.from(template.content.querySelectorAll('script'))

      for (const script of scripts) {
        script.remove()
      }

      container.appendChild(template.content.cloneNode(true))

      for (const source of scripts) {
        if (cancelled) return

        const script = document.createElement('script')

        for (const { name, value } of Array.from(source.attributes)) {
          script.setAttribute(name, value)
        }

        // Dynamically inserted external scripts are async by default.
        // Force synchronous loading unless async is explicitly requested.
        if (source.src && !source.hasAttribute('async')) {
          script.async = false
        }

        script.text = source.text

        if (source.src) {
          await new Promise((resolve, reject) => {
            script.onload = () => resolve()
            script.onerror = () =>
              reject(new Error(`Failed to load script: ${source.src}`))
            container.appendChild(script)
          }).catch((error) => {
            console.error(error)
          })
        } else {
          container.appendChild(script)
        }
      }
    }

    void renderEmbed()

    return () => {
      cancelled = true
      observer?.disconnect()
    }
  }, [block.settings.copy])

  return <div ref={containerRef} />
}

export default HtmlBlock
